import type { RouteObject } from 'react-router';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { SignUpPage } from './pages/SignUp';
import { DashboardPage } from './pages/Dashboard';
import { BucketsPage } from './pages/Buckets';
import { BucketDetailPage } from './pages/BucketDetail';
import { TransformPage } from './pages/Transform';
import { TokensPage } from './pages/settings/Tokens';
import { TeamPage } from './pages/settings/Team';
import { WebhooksPage } from './pages/settings/Webhooks';
import { AuditPage } from './pages/settings/Audit';
import { UsagePage } from './pages/settings/Usage';
import { PlanPage } from './pages/settings/Plan';

export const router: RouteObject[] = [
  { path: '/login', Component: LoginPage },
  { path: '/signup', Component: SignUpPage },
  {
    path: '/',
    Component: Layout,
    children: [
      { index: true, Component: DashboardPage },
      { path: 'dashboard', Component: DashboardPage },
      { path: 'buckets', Component: BucketsPage },
      { path: 'buckets/:id', Component: BucketDetailPage },
      { path: 'transform', Component: TransformPage },
      { path: 'settings/tokens', Component: TokensPage },
      { path: 'settings/team', Component: TeamPage },
      { path: 'settings/webhooks', Component: WebhooksPage },
      { path: 'settings/audit', Component: AuditPage },
      { path: 'settings/usage', Component: UsagePage },
      { path: 'settings/plan', Component: PlanPage },
    ],
  },
];
